import { requestDealerDownloadLoanEtc } from 'utils/http/api/dealer/loans';
import useModal from 'utils/modal/useModal';

export function useDealerFinancingDetailAdditionalDocumentsLogics(loanId: number) {
  const modal = useModal();
  // 대출 기타 파일 다운로드 호출
  const onClickDownloadLoanEtc = async (e: any, loanEtcAttachmentId: number) => {
    e.preventDefault();
    try {
      await requestDealerDownloadLoanEtc(loanId, loanEtcAttachmentId);
    } catch (e: any) {
      modal.show(e);
    }
  };

  return { onClickDownloadLoanEtc };
}
